import { NgModule } from '@angular/core';
import { DirectivesModule } from '@pg-app/shared/directives/directives.module';
import { DebounceButtonComponent } from './debounce-button.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    DirectivesModule,
    CommonModule
  ],
  declarations: [DebounceButtonComponent],
  exports: [DebounceButtonComponent]
})
export class DebounceButtonModule { }